import React, {
  useMemo,
  useState,
  useEffect,
} from "react";

import { useNavigate } from "react-router-dom";

import { TfiLocationPin } from "react-icons/tfi";

import ApiService from "../../../nhrc_apis/ApiService";

const { JobAPI } = ApiService;

/* =========================================
   HELPER : DEADLINE STATUS
========================================= */

const getJobStatusByDeadline = (
  deadline
) => {

  if (!deadline)
    return "Open";

  try {

    const today =
      new Date();

    today.setHours(
      0,
      0,
      0,
      0
    );

    const jobDeadline =
      new Date(deadline);

    jobDeadline.setHours(
      0,
      0,
      0,
      0
    );

    // ✅ FIXED — missing "<" operator restored
    return jobDeadline < today

      ? "Closed"

      : "Open";

  } catch (error) {

    return "Open";
  }
};

function AdminjobList() {

  const navigate =
    useNavigate();

  /* =========================================
     STATES
  ========================================= */

  const [page, setPage] =
    useState(1);

  const pageSize = 3;

  const [jobs, setJobs] =
    useState([]);

  const [
    applicationsMap,
    setApplicationsMap,
  ] = useState({});

  const [
    searchInput,
    setSearchInput,
  ] = useState("");

  const [
    selectedIds,
    setSelectedIds,
  ] = useState([]);

  const [filters, setFilters] =
    useState({
      status: "",
    });

  const [loading, setLoading] =
    useState(false);

  /* =========================================
     UNIQUE JOB ID
  ========================================= */

  const getUniqueJobId = (
    job,
    index
  ) => {

    return (

      job?.job_id ||

      job?.id ||

      job?.jobId ||

      job?._id ||

      `${index}`
    );
  };

  /* =========================================
     LOAD JOBS
  ========================================= */

  useEffect(() => {

    fetchAllJobs();

  }, []);

  const fetchAllJobs =
    async () => {

      try {

        setLoading(true);

        console.log(
          "FETCHING ALL JOBS..."
        );

        const response =
          await JobAPI.getAllJobs();

        console.log(
          "ALL JOBS RESPONSE :",
          response
        );

        let apiJobs = [];

        if (
          Array.isArray(
            response?.data
          )
        ) {

          apiJobs =
            response.data;

        } else if (
          Array.isArray(
            response?.data?.jobs
          )
        ) {

          apiJobs =
            response.data.jobs;

        } else if (
          Array.isArray(
            response?.data?.data
          )
        ) {

          apiJobs =
            response.data.data;
        }

        console.log(
          "ALL API JOBS :",
          apiJobs
        );

        /* =====================================
           FILTER ONLY ADMIN JOBS
        ===================================== */

        const adminJobs =
          apiJobs.filter(
            (job) => {

              const creatorRole = (
                job?.creator_role ||

                job?.role ||

                ""
              )
                .toString()
                .trim()
                .toUpperCase();

              return (
                creatorRole ===
                "ADMIN"
              );
            }
          );

        console.log(
          "ADMIN JOBS :",
          adminJobs
        );

        setJobs(
          adminJobs
        );

      } catch (error) {

        console.log(
          "LOAD JOBS ERROR :",
          error
        );

        console.log(
          "ERROR RESPONSE :",
          error?.response?.data
        );

        alert(
          "Failed to load jobs"
        );

      } finally {

        setLoading(false);
      }
    };

  /* =========================================
     LOAD APPLICATIONS FOR EACH JOB
  ========================================= */

  useEffect(() => {

    if (jobs.length > 0) {

      fetchAllApplications();
    }

  }, [jobs]);

  const fetchAllApplications =
    async () => {

      try {

        const applicationsData =
          {};

        for (const job of jobs) {

          const jobId =

            job?.job_id ||

            job?.id;

          try {

            console.log(
              "FETCHING APPLICATIONS FOR JOB :",
              jobId
            );

            const response =
              await JobAPI.getApplicationsByJob(
                jobId
              );

            console.log(
              "APPLICATION RESPONSE :",
              response
            );

            let applications =
              [];

            if (
              Array.isArray(
                response?.data
              )
            ) {

              applications =
                response.data;

            } else if (
              Array.isArray(
                response?.data
                  ?.applications
              )
            ) {

              applications =
                response.data
                  .applications;

            } else if (
              Array.isArray(
                response?.data
                  ?.data
              )
            ) {

              applications =
                response.data.data;
            }

            console.log(
              "APPLICATIONS :",
              applications
            );

            applicationsData[
              jobId
            ] = applications;

          } catch (error) {

            console.log(
              "APPLICATION FETCH ERROR :",
              error
            );

            console.log(
              "APPLICATION ERROR RESPONSE :",
              error?.response?.data
            );

            applicationsData[
              jobId
            ] = [];
          }
        }

        console.log(
          "FINAL APPLICATION MAP :",
          applicationsData
        );

        setApplicationsMap(
          applicationsData
        );

      } catch (error) {

        console.log(
          "ALL APPLICATION ERROR :",
          error
        );
      }
    };

  /* =========================================
     FILTER JOBS
  ========================================= */

  const filteredJobs =
    useMemo(() => {

      return jobs.filter(
        (job) => {

          const title =
            job?.title || "";

          const location =
            job?.location ||
            "";

          return (

            title
              .toLowerCase()
              .includes(
                searchInput.toLowerCase()
              )

            ||

            location
              .toLowerCase()
              .includes(
                searchInput.toLowerCase()
              )
          );
        }
      );

    }, [jobs, searchInput]);

  /* =========================================
     JOB COUNTS
  ========================================= */

  const jobsWithCounts =
    useMemo(() => {

      return filteredJobs.map(
        (
          job,
          index
        ) => {

          const uniqueId =
            getUniqueJobId(
              job,
              index
            );

          const applications =

            applicationsMap[
              uniqueId
            ] || [];

          console.log(
            "JOB APPLICATIONS :",
            uniqueId,
            applications
          );

          /* =================================
             SHORTLIST COUNT
          ================================= */

          const shortlistedCount =

            applications.filter(
              (app) => {

                const status = (
                  app?.status ||

                  app?.application_status ||

                  ""
                )
                  .toString()
                  .toLowerCase();

                return (
                  status ===
                  "shortlisted"
                );
              }
            ).length;

          /* =================================
             REJECT COUNT
          ================================= */

          const rejectedCount =

            applications.filter(
              (app) => {

                const status = (
                  app?.status ||

                  app?.application_status ||

                  ""
                )
                  .toString()
                  .toLowerCase();

                return (
                  status ===
                  "rejected"
                );
              }
            ).length;

          return {

            ...job,

            uniqueId,

            totalResponses:
              applications.length,

            shortlisted:
              shortlistedCount,

            rejected:
              rejectedCount,

            jobStatus:
              getJobStatusByDeadline(
                job?.application_deadline
              ),
          };
        }
      );

    }, [
      filteredJobs,
      applicationsMap,
    ]);

  /* =========================================
     PAGINATION
  ========================================= */

  const totalPages =
    Math.max(
      1,
      Math.ceil(
        jobsWithCounts.length /
          pageSize
      )
    );

  const currentJobs =
    useMemo(() => {

      const startIndex =
        (page - 1) *
        pageSize;

      return jobsWithCounts.slice(
        startIndex,
        startIndex +
          pageSize
      );

    }, [
      jobsWithCounts,
      page,
    ]);

  useEffect(() => {

    if (
      page > totalPages
    ) {

      setPage(1);
    }

  }, [totalPages]);

  /* =========================================
     PAGINATION HANDLERS
  ========================================= */

  const handlePrevPage =
    () => {

      setPage((prev) =>
        Math.max(
          1,
          prev - 1
        )
      );
    };

  const handleNextPage =
    () => {

      setPage((prev) =>
        Math.min(
          totalPages,
          prev + 1
        )
      );
    };

  /* =========================================
     SELECT ALL
  ========================================= */

  const allSelected =

    currentJobs.length > 0 &&

    currentJobs.every(
      (job) =>

        selectedIds.includes(
          job.uniqueId
        )
    );

  const handleToggleSelectAll =
    (e) => {

      if (
        e.target.checked
      ) {

        setSelectedIds(

          currentJobs.map(
            (job) =>
              job.uniqueId
          )
        );

      } else {

        setSelectedIds([]);
      }
    };

  const handleToggleSelect =
    (uniqueId) => {

      setSelectedIds(
        (prev) =>

          prev.includes(
            uniqueId
          )

            ? prev.filter(
                (id) =>
                  id !==
                  uniqueId
              )

            : [
                ...prev,
                uniqueId,
              ]
      );
    };

  const handleSearch =
    () => {

      setPage(1);
    };

  /* =========================================
     DELETE
  ========================================= */

  const handleDelete =
    async () => {

      if (
        !selectedIds.length
      ) {

        return alert(
          "Please select job(s)"
        );
      }

      if (
        !window.confirm(

          `Delete ${selectedIds.length} job(s)?`
        )
      ) {

        return;
      }

      try {

        for (const id of selectedIds) {

          await JobAPI.deleteJob(
            id
          );
        }

        const updatedJobs =
          jobs.filter(
            (
              job,
              index
            ) => {

              const id =
                getUniqueJobId(
                  job,
                  index
                );

              return !selectedIds.includes(
                id
              );
            }
          );

        setJobs(
          updatedJobs
        );

        setSelectedIds([]);

        setPage(1);

        alert(
          "Jobs deleted successfully"
        );

      } catch (error) {

        console.log(
          error
        );

        alert(
          "Failed to delete jobs"
        );
      }
    };

  /* =========================================
     NAVIGATION
  ========================================= */

  const handleAddJob =
    () => {

      navigate(
        "/dashboard/Adminjobpost"
      );
    };

  const handlePreview =
    (job) => {

      navigate(
        "/dashboard/Adminjobpost",
        {
          state: {
            editJob: job,
          },
        }
      );
    };

  const handleViewResponses =
    (job) => {

      navigate(

        `/dashboard/AdminResponses/${job.uniqueId}`,

        {
          state: {

            jobTitle:
              job.title,

            jobId:
              job.uniqueId,
          },
        }
      );
    };

  /* =========================================
     UI
  ========================================= */

  return (

    <section className="Hrjobpost mt-4">

      <h3
        className="training-title mt-1 fw-bold"
        style={{
          color: "#8D0000",
        }}
      >
        Admin Job Posts
      </h3>

      <div className="container mt-5">

        <div className="d-flex justify-content-between align-items-center mb-3">

          <div>

            <h5 className="mb-0">

              Admin Posted Jobs

            </h5>

            <small className="text-muted">

              Total :
              {" "}
              {filteredJobs.length}
              {" "}of{" "}
              {jobs.length}

            </small>

          </div>

          <button
            className="btn btn-success btn-sm d-flex align-items-center gap-1 p-2"
            onClick={
              handleAddJob
            }
          >

            <i className="bi bi-plus-lg"></i>

            + Post Job

          </button>

        </div>

        <div className="bg-light border rounded-3 p-3 mb-4 d-flex flex-wrap align-items-center gap-3">

          <div className="form-check ms-1">

            <input
              type="checkbox"
              className="form-check-input"
              style={{
                transform:
                  "scale(0.8)",
                accentColor:
                  "#0d6efd",
              }}
              checked={
                allSelected
              }
              onChange={
                handleToggleSelectAll
              }
            />

            <label className="form-check-label ms-1">

              Select All

            </label>

          </div>

          <div className="flex-grow-1 d-flex gap-2">

            <input
              type="text"
              className="form-control"
              placeholder="Search by Job Title or Location..."
              value={
                searchInput
              }
              onChange={(e) => {

                setSearchInput(
                  e.target.value
                );

                setPage(1);
              }}
            />

            <button
              className="btn btn-primary px-4"
              onClick={
                handleSearch
              }
            >

              Search

            </button>

          </div>

          <button
            className="btn btn-outline-danger"
            onClick={
              handleDelete
            }
          >

            Delete (
            {selectedIds.length}
            )

          </button>

        </div>

        {loading && (

          <div className="text-center py-5">

            <div className="spinner-border text-primary" />

          </div>
        )}

        {!loading &&

          currentJobs.length >
            0 &&

          currentJobs.map(
            (
              job,
              index
            ) => (

              <div
                key={
                  job.uniqueId
                }
                className="card mb-3 shadow-sm border-0"
              >

                <div className="card-body">

                  <div className="d-flex justify-content-between align-items-start mb-2">

                    <div className="d-flex align-items-start gap-2">

                      <input
                        type="checkbox"
                        className="form-check-input mt-1"
                        style={{
                          transform:
                            "scale(0.8)",
                          accentColor:
                            "#0d6efd",
                        }}
                        checked={

                          selectedIds.includes(
                            job.uniqueId
                          )
                        }
                        onChange={() =>

                          handleToggleSelect(
                            job.uniqueId
                          )

                        }
                      />

                      <div>

                        <h6 className="mb-1">

                          Job Title :-
                          {" "}
                          {job.title}

                        </h6>

                        <small className="text-muted">

                          <TfiLocationPin />

                          {" "}
                          Location :-
                          {" "}
                          {job.location}

                        </small>

                        <div className="small mt-1">

                          <span className="fw-bold text-primary">

                            Created By :

                          </span>

                          {" "}
                          {job.created_by}

                          {" | "}

                          <span className="fw-bold text-success">

                            Role :

                          </span>

                          {" "}
                          {job.creator_role}

                        </div>

                      </div>

                    </div>

                    <button
                      className="btn btn-outline-primary btn-sm"
                      onClick={() =>

                        handlePreview(
                          job
                        )

                      }
                    >

                      Job Preview

                    </button>

                  </div>

                  <div className="d-flex flex-wrap justify-content-center gap-4 my-2">

                    <button
                      className="btn btn-sm btn-outline-primary d-flex flex-column align-items-center"
                      onClick={() =>

                        handleViewResponses(
                          job
                        )

                      }
                    >

                      <span className="fw-semibold">

                        {
                          job.totalResponses
                        }

                      </span>

                      <span className="small">

                        Total Responses

                      </span>

                    </button>

                    <button className="btn btn-sm btn-outline-success d-flex flex-column align-items-center">

                      <span className="fw-semibold">

                        {
                          job.shortlisted
                        }

                      </span>

                      <span className="small">

                        Shortlist

                      </span>

                    </button>

                    <button className="btn btn-sm btn-outline-danger d-flex flex-column align-items-center">

                      <span className="fw-semibold">

                        {
                          job.rejected
                        }

                      </span>

                      <span className="small">

                        Rejected

                      </span>

                    </button>

                  </div>

                </div>

              </div>
            )
          )}

        {!loading &&
          currentJobs.length ===
            0 && (

            <div className="text-center py-5">

              <h6 className="text-muted">

                No Admin jobs found

              </h6>

            </div>
          )}

        {/* PAGINATION — Previous / Next */}
        {!loading &&
          jobsWithCounts.length >
            0 && (

            <div className="d-flex justify-content-center align-items-center gap-3 mt-4 mb-3">

              <button
                className="btn btn-outline-secondary btn-sm px-3"
                onClick={
                  handlePrevPage
                }
                disabled={
                  page === 1
                }
              >

                Previous

              </button>

              <span className="fw-semibold">

                Page {page} of {totalPages}

              </span>

              <button
                className="btn btn-outline-secondary btn-sm px-3"
                onClick={
                  handleNextPage
                }
                disabled={
                  page === totalPages
                }
              >

                Next

              </button>

            </div>
          )}

      </div>

    </section>
  );
}

export default AdminjobList;